import { IBoExtra } from "@core/models/back-office/extra.model";
import { IBoAddress } from "@core/models/back-office/address.model";

export const aeExtraListMock = [
  {
    [IBoExtra.extraId]: 12040,
    [IBoExtra.firstname]: "Bobby",
    [IBoExtra.lastname]: "Brown",
    [IBoExtra.phone]: "0743567890",
    [IBoExtra.address]: {
      [IBoAddress.street]: "104 rue d'hauteville",
      [IBoAddress.postalCode]: "75010",
      [IBoAddress.city]: "Paris",
    },
    [IBoExtra.status]: "pending",
    [IBoExtra.alert]: "CNI expire bientôt",
  },
  {
    [IBoExtra.extraId]: 123,
    [IBoExtra.firstname]: "Joris",
    [IBoExtra.lastname]: "DUPONT",
    [IBoExtra.phone]: "0590123478",
    [IBoExtra.address]: {
      [IBoAddress.street]: "82 rue d'hauteville",
      [IBoAddress.postalCode]: "75010",
      [IBoAddress.city]: "Paris",
    },
    [IBoExtra.status]: "verified",
    [IBoExtra.alerts]: "CNI expire bientôt",
  },
];
